var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-track"},[_c('div',{staticClass:"progress-fill",style:({ width: `${_vm.progress}%` })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }